export default "__VITE_ASSET__J9e9Urj0__"